import React from 'react'
import { injectIntl } from 'react-intl'
import menuIconsSprite from 'assets/img/menu-icons/sprite.svg'

import styles from './styles.module.scss'

const Diagnostics = ({ position, showExactPosition, intl: { formatMessage } }) => {
  if (!position || parseInt(position, 10) === 0)
   return null;

  return (
    <div className={styles.top}>
      <svg width={8} height={8} className={styles.growingTrangle}>
        <use href={`${menuIconsSprite}#growing-trangle`} />
      </svg>
      <span>{formatMessage({ id: "menu.left.profileSnippet.diagnostics.top" })} {getTop(position)}</span>
      {showExactPosition && <span className={styles.exactPosition}>#{position}</span>}
    </div>
  )
}

export default injectIntl(Diagnostics)

const getTop = (position) => {
  if (position <= 0) {
    return null
  }

  if (position <= 3) {
    return 3
  }

  if (position <= 5) {
    return 5
  }

  if (position <= 10) {
    return 10
  }

  if (position <= 20) {
    return 20
  }

  if (position <= 50) {
    return 50
  }

  if (position <= 100) {
    return 100
  }

  return null
}
